<template>
  <avs-chip
    v-bind="{ ...$attrs }"
    v-on="{ ...$listeners }"
    icon="mdi-account-settings"
    color="secondary"
    outlined
    small
    :label="false"
    class="text-uppercase"
    style="width: 170px"
  >
    {{ get_status(role) }}
  </avs-chip>
</template>

<script>
export default {
  name: "ClosedChip",
  props: {
    role: {
      type: String
    }
  },
  methods: {
    get_status(role) {
      if (role == "operator") {
        return this.$t("commons.operator")
      } else if (role == "inspector") {
        return this.$t("commons.inspector")
      } else {
        return this.$t("commons.adminitrator")
      }
    }
  }
}
</script>
